import { render, staticRenderFns } from "./n-select.vue?vue&type=template&id=0becfd47&scoped=true"
import script from "./n-select.vue?vue&type=script&lang=js"
export * from "./n-select.vue?vue&type=script&lang=js"
import style0 from "./n-select.vue?vue&type=style&index=0&id=0becfd47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becfd47",
  null
  
)

export default component.exports